export default __webpack_public_path__ + "static/media/svg-3.9ff64cab.svg";